export const roundToUnit = value => {
  if (typeof value === "number") {
    value = Math.round(value);

    return value;
  }
  return value;
};
